import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  sidebar: {
    whiteSpace: 'nowrap',
    width: '100vw',
    overflowX: 'hidden',
    backgroundColor: theme.palette.primary.dark,
    borderRight: 'none',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.up('sm')]: {
      width: theme.sidebarWidth,
    },
  },
  sidebarHeader: {
    display: 'none',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1, 2),
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
    },
  },
  sidebarButton: {
    color: theme.palette.common.white,
  },
  sidebarClose: {
    width: 0,
    [theme.breakpoints.up('sm')]: {
      width: theme.sidebarWidthClose,
    },
  },
  sidebarLanding: {
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
}))

export default useStyles
